var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["size", "color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

var React = require("react");

module.exports = function (a) {
  var _a$size = a.size,
      c = _a$size === void 0 ? "1em" : _a$size,
      _a$color = a.color,
      d = _a$color === void 0 ? "#6dd0c7" : _a$color,
      b = _objectWithoutProperties(a, _excluded);

  return b = _objectSpread(_objectSpread({}, b), {}, {
    style: _objectSpread(_objectSpread({}, b.style ? b.style : {}), {}, {
      width: c,
      height: c
    }, d ? {
      fill: d
    } : {})
  }), /*#__PURE__*/React.createElement("svg", _extends({}, b, {
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7 10.1c.3.1 2.2.7 6 7.2 2.6 4.4 5.6 10.9 9 19.1 6.3 15.2 12.8 33.9 17.5 47.5 1.5 4.4 2.8 8.1 3.8 11-1.3-1.1-2.7-2.2-4.1-3.3-7.2-5.6-12.6-8.3-16.3-8.3h-.2c-7.1.2-12.5 6.4-20.1 14.9-2.4 2.7-5.1 5.8-8.2 9.1-8 8.4-13.2 10.7-15.6 11.4-3.6-11.6-7.6-20.2-12.1-25.5-2.6-3.1-5.2-5.2-8-6.2l5.9-4.1.1-.1.1-.1c7.4-6 15.3-17.6 23.4-34.3 6-12.4 9.9-23.1 9.9-23.2l.1-.2v-.2c3.1-14.4 8.6-14.7 8.8-14.7m0-2.2c-1.3 0-7.7.8-11.1 16.6 0 0-15.4 42.5-32.6 56.5l-12.5 8.7c.8-.5 2.3-1.1 4.2-1.1 5.3 0 14 5.1 22.2 32.6h.2c1.1 0 7.6-.6 18.7-12.3 12.3-13 18.6-23.1 26.7-23.3h.1c7.5 0 23.6 15.1 26.1 17.5C124 97 98 9.3 86 7.9h-.3zM29.6 89.7c-.5.3-.8.6-.8.6l.8-.6zm98.1 13.3c.1.2.2.3.3.3l-.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: "0",
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: "0",
      shapeMargin: "0",
      inlineSize: "0",
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: "1"
    },
    d: "M38.73 52.746L1.068 69.672l27.473 21.215.318.011c.724.03 1.27-.214 2.096-.566.826-.352 1.829-.859 2.969-1.502 2.28-1.286 5.102-3.12 7.996-5.336 5.788-4.433 11.882-10.346 14.312-16.633l.274-.705-.604-.455L38.73 52.746zm-.26 2.309l15.55 11.732c-2.354 5.412-7.895 10.968-13.315 15.12-2.818 2.158-5.578 3.948-7.764 5.18-1.092.617-2.043 1.096-2.77 1.405-.6.257-.917.306-1.02.338L4.93 70.13l33.54-15.074z",
    fontFamily: "sans-serif"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: "0",
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: "0",
      shapeMargin: "0",
      inlineSize: "0",
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: "1"
    },
    d: "M79.008 14a1 1 0 00-.88.51c-6.613 11.736-11.63 17.602-15.554 20.65-3.924 3.048-6.718 3.347-9.49 3.963l.016-.002c-1.665.34-3.313 1.437-4.985 2.832-1.672 1.395-3.342 3.116-4.838 4.795a89.432 89.432 0 00-5.29 6.57 1 1 0 00.23 1.395 1 1 0 001.396-.23s2.25-3.139 5.158-6.405c1.455-1.633 3.073-3.294 4.625-4.59 1.553-1.295 3.069-2.197 4.104-2.408a1 1 0 00.018-.004c2.627-.584 6.032-1.034 10.283-4.336 4.25-3.302 9.384-9.386 16.07-21.25a1 1 0 00-.38-1.361 1 1 0 00-.483-.129z",
    fontFamily: "sans-serif"
  }));
};